"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const WizardFlow_1 = __importDefault(require("@Components/WizardFlow"));
const common_1 = require("@Const/common");
const contexts_1 = require("@App/contexts");
const WizardRegisterWorkFlow = () => {
    const { wizardFlowStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const flow = [
        {
            stepIndicator: {
                icon: common_1.ICONS.search,
                label: 'Search',
            },
            forms: [react_1.default.createElement("form", { key: 1 }, "1. Search Form")],
        },
        {
            stepIndicator: {
                icon: common_1.ICONS.workDetails,
                label: 'Enter Work Details',
            },
            forms: [react_1.default.createElement("form", { key: 2 }, "2. Work Details Form")],
        },
        {
            stepIndicator: {
                icon: common_1.ICONS.writers,
                label: 'Add Writers',
            },
            forms: [react_1.default.createElement("form", { key: 3 }, "3. Add Writers")],
        },
        {
            stepIndicator: {
                icon: common_1.ICONS.publishers,
                label: 'Add Publishers & Shares',
            },
            forms: [react_1.default.createElement("form", { key: 4 }, "4. Add Publishers & Shares")],
        },
        {
            stepIndicator: {
                icon: common_1.ICONS.recordings,
                label: 'Add Recording',
            },
            forms: [react_1.default.createElement("form", { key: 5 }, "5. Add Recording")],
        },
        {
            stepIndicator: {
                icon: common_1.ICONS.workDetails,
                label: 'Review',
            },
            forms: [react_1.default.createElement("form", { key: 6 }, "6. Review")],
        },
    ];
    wizardFlowStore.setFlow(flow);
    return react_1.default.createElement(WizardFlow_1.default, { heading: 'Wizard Flow' });
};
exports.default = WizardRegisterWorkFlow;
